import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Label = styled.label`
  color: #263238;
  font-size: 14px;
  display: flex;
  cursor: pointer;
  margin: 0;
`

const InnerCheck = styled.input`
  display: none;
`

const FauxCheck = styled.div`
  border: 1px solid #BABABA;
  width: 16px;
  height: 16px;
  position: relative;
  cursor: pointer;
  display: inline-block;
  margin-right: 5px;
`

const Checkmark = styled.div`
  border-bottom: 2px solid #93C13E;
  border-left: 2px solid #93C13E;
  width: 11px;
  height: 5px;
  transform: rotate(-45deg);
  position: absolute;
  top: 3px;
  left: 2px;

  ${({ checked }) => !checked && `display: none;`}
`

class CheckInput extends Component {
  render () {
    const { props } = this
    return (
      <Label {...props}>
        <FauxCheck>
          <Checkmark checked={props.value} />
        </FauxCheck>
        <InnerCheck
          type='checkbox'
          {...props}
        />
        {props.label}
      </Label>
    )
  }
}

CheckInput.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func
}

export default CheckInput



// WEBPACK FOOTER //
// ./src/components/CheckInput/index.js